if ( pplang == 'es') {


    // Notices = //
    var locale = 'es';
    var helpurl = 'https://ultrapassport.com/help';
    var _globalnotice = `¡Ya puedes registrarse para comprar las entradas de ${regname}! &nbsp;&nbsp; <a href="${regurl}"><em>inscríbirte Aquí</em> <i class="fas fa-chevron-right"></i></a>`;
    var _globalnotice2 = `¡Registro de entradas de ${regname} ya está abierto!`;
    var _globalnoticereg = '¡Revise su correo electrónico! Hemos enviado instrucciones para la venta de entradas de mañana.';
    var _maintenance = 'Ultra Passport no está disponible en este momento, por favor revise de nuevo pronto.';
    var _guestnotice = 'Debe iniciar una nueva sesión para ver esta página.';
    var _fullname = 'Nombre y apellido';
    var _firstname = 'Nombre';
    var _lastname = 'Apellido';
    var _email = 'Correo Electrónico';
    var _emailaddy = 'Dirección de correo electrónico';
    var _confirmemailaddy = 'Confirmar dirección de email';
    var _birthday = 'Fecha de Nacimento';
    var _location = 'Ubicación';
    var _country = 'País';
    var _homeevent = 'Evento local';
    var _gender = 'Sexo';
    var _male = 'Masculino';
    var _female = 'Femenino';
    var _pleaseselect = 'Por favor, seleccione';
    var _signuptitle = 'Inscripción del Ultra Passport';
    var _enteryouremail = 'Introduzca su dirección de correo electrónico';
    var _backtologin = 'Volver a Inicio de sesión';
    var _requestnewpass = 'Solicitar nueva contraseña';
    var _on = 'Encendido';
    var _off = 'Apagado';
    var _lwidth = '3em';
    var _enrollmentavailable = 'Inscripción ya disponible';
    var _logintext = 'Iniciar sesión';
    var _password = 'Contraseña';
    var _welcome = 'Bienvenido';
    var _account = 'Cuenta';
    var _myaccount = 'Mi Cuenta';
    var _mypassport = 'Mi Passport';
    var _events = 'Eventos';
    var _points = 'Puntos';
    var _updates = 'Actualizaciones';
    var _signout = 'Cerrar sessión';
    var _signin = 'Iniciar sesión';
    var _signedin = 'Conectado';
    var _signuptext = 'Crear cuenta nueva';
    var _nextlevel = 'Siguiente nivel';
    var _forgot = '¿Ha olvidado su contraseña?';
    var _subscribed = 'Suscrito';
    var _helpcenter = 'Preguntas';
    var _error = 'Error';
    var _silver = 'Plata';
    var _gold = 'Oro';
    var _platinum = 'Platíno';
    var _gendertext = 'Debe especificar su sexo';
    var _accepttext = 'Debe aceptar los términos';
    var _resendverify = 'Reenviar verificación';
    var _revalidate = 'Por favor revise su correo electrónico para validar su dirección de correo electrónico.';
    var _sendingverification = 'Enviando verificación de correo electrónico...';
    var _verifysent = 'La verificación de correo electrónico ha sido enviada.';
    var _emailverifydashboard = 'Asegúrese de verificar su dirección de correo electrónico para tener acceso a actualizaciones y registros de boletos.';
    var _emailverifyupdates = 'Asegúrese de verificar su correo electrónico para activar las actualizaciones por correo electrónico.';
    var _editaccount = 'Editar cuenta';
    var _nochanges = 'No se detectaron cambios';
    var _accountupdated = 'Cuenta actualizada';
    var _emailupdatedstarted = 'Nuevas direcciones de correo electrónico deben ser verificadas. Por favor compruebe su correo electrónico para confirmar.';
    var _emailupdatedverified = 'Su nueva dirección de correo electrónico ha sido verificada.';
    var _passwordresetsent = 'Correo electrónico de restablecimiento de contraseña ha sido enviado.';
    var _startinput = 'Introduzca su dirección de correo electrónico para empezar...';
    var _starttext = '¿No tienes una cuenta? ¡Abre una cuenta para inscribirte en los eventos, ganar puntos y mucho más!';
    var _getstarted = 'Empezar';
    var _createaccount = 'Crear mi cuenta';
    var _almost = 'Falta poco...';
    var _almost2 = '¡Felicidades por crear su nueva cuenta Ultra Passport $user_firstname!';
    var _almost3 = 'Para activar su cuenta, <strong><u>usted debe validar su dirección de correo electrónico</u></strong> haciendo clic en el enlace de confirmación que acabamos de enviar a <strong>$user_email</strong>.';
    var _almost4 = 'Si usted no ha recibido ningún correo electrónico <strong><u>por favor revise su carpeta de (spam) y agrega info@ultrapassport.com</strong></u> a sus contactos.';
    var _almost5 = 'Continuar';
    var _createdsuccess = 'Su cuenta ha sido creada.';
    var _createdinfo = 'Su Cuenta está siendo creada:';
    var _accountactivated = 'Su cuenta ya está activada.';
    var _accountverified = 'Su dirección de correo electrónico ha sido verificada.';
    var _passwordresetsuccess = 'Su contraseña ha sido restablecida';
    var _updatestext1 = 'Debe iniciar una sesión para seleccionar actualizaciones.';
    var _updatestextPending = 'Por favor verifique su dirección de correo electrónico para recibir actualizaciones.';
    var _updatessubsrcibe = 'Se suscribió para recibir actualizaciones para:';
    var _updatesunsubsrcibe = 'Se ha cancelado la suscripción para recibir actualizaciones de:';
    var _rbtnbuy = 'Comprar entradas ahora';
    var _regbuy = 'Comprar entradas';
    var _rbtnregister = 'Regístrate Para Las Entradas';
    var _rbtnclosed = 'Cerrado';
    var _rbtnsoon = 'Próximamente';
    var _rbtnupdates = 'Recibir actualizaciones';
    var _rbtnwaitlist = 'Únete a la lista';
    var _verifyemailregister = 'Debe verificar su dirección de correo electrónico antes de registrarse.';
    var _regbtnhtml = 'Registrado';
    var _regerror = 'Error !';
    var _regerror2 = 'Por favor, intente de nuevo.';
    var _regprocessing = 'Su registración está siendo procesanda...';
    var _registersuccess = 'Su registración fue aceptada';
    var _regaccepted = 'Su <u class="regtype"></u> registro fue aceptado el';
    var _regaccepted2 = 'Las instrucciones para comprar los entradas seran enviadas a su correo electrónico entre 24 y 48 horas antes de venta.';
    var _regaccepted2_4 = 'Serás el primero en saber cuando las Entradas están disponibles. Permanece atento.';
    var _regdone1 = 'Código de registro';
    var _regdone2 = 'Ustéd se registró el';
    var _regdone3 = 'Reenviar instrucciones de compra';
    var _regtext1 = '¿Está actualizada su información?';
    var _regtext2 = 'Por favor confirme su información de registro para';
    var _regguest1 = 'Debe iniciar sesión para registración en eventos.';
    var _regpending1 = 'Ya casi está allí.';
    var _regpending2 = 'Verificar su correo electrónico para accesar su cuenta.';
    var _updateinfobtn = 'Actualizar mis datos';
    var _confirmreg = 'Confirmar mi registro';

    var _waitlistguest1 = 'Debes iniciar sesión para inscribirte al waitlist.';
    var _waitlistbtnjoin = 'Inscribete al waitlist';
    var _waitlistbtnjoined = 'Inscrito';
    var _waitlistdone = 'Te inscribiste al waitlist en';
    var _waitlistsuccess = '¡Estás en el waitlist!';
    var _waitlistpending2 = 'Por favor, verifica tu <strong>correo electrónico</strong> para acceder al waitlist.';

    var privacytext = 'Política de Privacidad';
    var termsofuse = 'Términos de Uso';
    var upptextlogo = 'Ultra Passport<span class="tm">&trade;</span>';
    var privacylink = `<a href="https://ultrapassport.com/privacy-policy" target="_blank">${privacytext}</a>`;
    var termslink = `<a href="https://ultrapassport.com/terms-of-use" target="_blank">${termsofuse}</a>`;
    var _agreesignup = `Yo acepto la ${privacylink} y los ${termslink} de ${upptextlogo}.`;
    var _agreesignup2 = `Al abrir una cuenta, usted acepta la ${privacylink} y ${termslink} de ${upptextlogo}.`;
    var _agreeregister = `Al inscribirse, usted acepta la ${privacylink} y ${termslink} de ${upptextlogo}.`;
    var _agreewaitlist = `Al inscribirse, usted acepta la ${privacylink} y ${termslink} de ${upptextlogo}.`;

    // PASSPORT LABELS = '',
    var _action = 'Acción';
    var _awarded = 'Otorgados';
    var _award = 'Premio';
    var _pointsexpire = 'Los puntos expiran después de 25 meses';
    var _qualifydisclaimer = 'Por favor, tenga en cuenta que un evento principal "Ultra Festival" excluye los eventos: Road to Ultra, Ultra Beach y Resistance.';
    var _benefit = 'Beneficio';
    var _sample = 'Puntos otorgados';
    var _active = 'Activo';
    var _deleted = 'Eliminados';
    var _btn_dashboard = 'Tablero de control';
    var _btn_benefits = 'Beneficios';
    var _btn_qualify = 'Califica';
    var _btn_points = 'Mis puntos';
    var _howtoqualify = 'Cómo calificar';
    var _points_manual = 'Ajuste de administrador de Passport';
    var _points_verify = 'Correo electrónico de la cuenta verificada';
    var _points_attend_festival = 'Asistir a un Ultra Festival completo';
    var _points_away_bonus = 'Asistir evento en otro continente';
    var _points_home_bonus_1 = 'Asistir evento casa';
    var _points_home_bonus_2 = 'Asistir evento casa x 2';
    var _points_home_bonus_3 = 'Asistir evento casa x 3';
    var leveltext = _silver;
    var nextlevel = _gold;


    // Errors
    var errors = {
        reset : 'Correo electrónico no válido o token caducado.',
        create : 'La creación de su cuenta falló, favor volver a intentar. ',
        general : 'Algo salio mal, por favor asegúrese de habilitar cookies.',
        password : 'La contraseña debe tener al menos 8 caracteres.',
        duplicateemail : 'Dirección de correo electrónico ya está en uso.',
        matchemail : 'Tu correo electrónico no coincide, por favor confirma y vuelve a ingresar tu correo electrónico.',
        loginfail : 'El nombre de usuario y la contraseña que ha introducido no coinciden en nuestro registro. Por favor revise y vuelva a intentarlo.',
        token : 'El codigo de acceso de seguridad no es valido',
        birthday : 'You must be 18 years of age or older to enroll in Ultra Passport.',
    };

    var pointcodes = {
        manual : 'Ajuste de administrador de Passport',
        unknown : 'Ajuste de administrador de Passport',
        verify : 'Correo electrónico de la cuenta verificada',
        attend_festival : 'Asistir a un Ultra Festival completo',
        attend_rtu : 'Asistir a un evento de Road to Ultra',
        attend_resistance : 'Asistir un evento únicamente de Resistance',
        away_bonus : 'Asistir evento en otro continente',
        home_bonus_1 : 'Asistir evento casa',
        home_bonus_2 : 'Asistir evento casa x 2',
        home_bonus_3 : 'Asistir evento casa x 3+',
        home_bonus_4 : 'Asistir evento casa x 3+',
        home_bonus_5 : 'Asistir evento casa x 3+',
        home_bonus_6 : 'Asistir evento casa x 3+',
        home_bonus_7 : 'Asistir evento casa x 3+',
        home_bonus_8 : 'Asistir evento casa x 3+',
        home_bonus_9 : 'Asistir evento casa x 3+',
    };

}
